import React from 'react';
import { render } from 'react-dom';
import App from '~/legacy/App';
import '~/legacy/styles/system.css';

render(<App />, document.getElementById('root'));
